import React from "react";
import styles from "./StepBar.module.css";

const StepBar = (props) => {
    let { groups, isShowFullName = true, showName= true } = props

    return(
        <ol className={styles.stepbar}>
            {groups.length > 0 && groups.map(group =>
                <li
                    key={group.key}
                    className={`${styles['stepbar__item']} ${group?.groupCompleted ? styles['stepbar__item--complete'] : ''}`}
                    data-step={group?.shortName}
                >
                    {showName ? `${isShowFullName ? group?.name: group?.midName}` : ""}
                </li>)}
        </ol>
    )
}

export default StepBar;